export default "__VITE_ASSET__DNIp52FU__"